export default __webpack_public_path__ + "static/mediumFont-5fce803cd55ac8649cec85897fdb8ac2.woff2";